import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class ClothesService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  save(clothes: any) {
    return this.authHttp.post("/api/clothes/", clothes).map(res => res.json());
  }

  update(clothes: any){
    return this.authHttp.put("/api/clothes/"+clothes.id, clothes).map(res => res.json());
  }

  delete(id: number){
    return this.authHttp.delete("/api/clothes/"+id).map(res => res.json());
  }

  getAllClothes(showHidden?: boolean){
    if (typeof showHidden !== 'undefined'){
      return this.authHttp.get("/api/clothes/"+showHidden).map(res => res.json());
    }
    return this.authHttp.get("/api/clothes/").map(res => res.json());
  }

  getClothesById(id: number){
    return this.authHttp.get("/api/clothes/"+id).map(res => res.json());
  }

  getClothesSizesById(id: number){
    return this.authHttp.get("/api/clothes/sizes/"+id).map(res => res.json());
  }

  getClothesAllSizes(){
    return this.authHttp.get("/api/clothes/sizes/").map(res => res.json());
  }

  getAmountOfCartForId(id:string){
    return this.authHttp.get('/api/clothes/cartamount/'+id).map( (res:any)=>{
      let value:any = {};
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    } )
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/clothes.service.ts